/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelSetExtraCee } from '../../models/dto-travel-set-extra-cee';
import { TravelItem } from '../../models/travel-item';

export interface TravelControllerSetExtraCee$Params {
  id: number;
      body: DtoTravelSetExtraCee
}

export function travelControllerSetExtraCee(http: HttpClient, rootUrl: string, params: TravelControllerSetExtraCee$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerSetExtraCee.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItem;
      }>;
    })
  );
}

travelControllerSetExtraCee.PATH = '/travel/{id}/extra_cee';
